import tw from "tailwind-styled-components";

const Badge = tw.span`
font-semibold
text-gray-700
items-center
rounded 
text-xs 
py-1
bg-gray-100
px-1
`;
export default Badge;
